import React, { createContext, useContext, useState, useEffect } from "react";

const LandsContext = createContext();

export const LandsProvider = ({ children }) => {
  const [allLands, setAllLands] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLands = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://akwan.areez.co/api/v1/GetProperties",
        {
          method: "GET",
        }
      );
      const data = await response.json();
      setAllLands(data.data);
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching lands:", error);
      setAllLands([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLands();
  }, []);

  const getLandById = (id) => {
    return allLands.find((land) => land.id === parseInt(id));
  };

  const filterLands = (locationFilter, priceFilter) => {
    return allLands.filter((land) => {
      const matchLocation = locationFilter
        ? land.location === locationFilter
        : true;

      const matchPrice =
        priceFilter === "lt100"
          ? land.price_amount < 100000
          : priceFilter === "100to300"
          ? land.price_amount >= 100000 && land.price_amount <= 300000
          : priceFilter === "gt500"
          ? land.price_amount > 500000
          : true;

      return matchLocation && matchPrice;
    });
  };

  const value = {
    allLands,
    isLoading,
    getLandById,
    filterLands,
    refetchLands: fetchLands,
  };

  return (
    <LandsContext.Provider value={value}>{children}</LandsContext.Provider>
  );
};

export const useLands = () => {
  const context = useContext(LandsContext);
  if (!context) {
    throw new Error("useLands must be used within a LandsProvider");
  }
  return context;
};
